import { render, staticRenderFns } from "./agendar.vue?vue&type=template&id=1474e3ae&"
import script from "./agendar.vue?vue&type=script&lang=js&"
export * from "./agendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports